import {
	AppBar,
	Box,
	Button,
	Container,
	FormControl,
	IconButton,
	Menu,
	MenuItem,
	Select,
	Toolbar,
	Typography,
} from "@mui/material";
import React from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { ExitToApp } from "@mui/icons-material";

var LINKS = [
	{
		name: "Pricing",
		link: "pricing",
	},
	{
		name: "Inventory",
		link: "inventory",
	},
	{
		name: "Decoration",
		link: "inksoftdecoration",
	},
	{
		name: "Advance",
		link: "inksoftadvanceorders",
	}
];

function NavigationBar(props) {
	const { domains, domainId, onSelectDomain } = props;
	const [anchorElNav, setAnchorElNav] = React.useState(
		null
	);
	let navigate = useNavigate();

	const handleOpenNavMenu = (event) => {
		setAnchorElNav(event.currentTarget);
	};

	const handleCloseNavMenu = (link) => {
		navigate(link);
		setAnchorElNav(null);
	};

	const signout = () => {
		const auth = getAuth();
		signOut(auth);
	}

	return (
		<AppBar position="static" elevation={3} sx={{"borderRadius": "0px"}}>
			<Container maxWidth="xl">
				<Toolbar disableGutters>
					<Typography
						variant="h6"
						noWrap
						component="div"
						onClick={() => handleCloseNavMenu("/home")}
						sx={{
							mr: 2,
							display: { xs: "none", md: "flex" },
							cursor: "pointer",
							fontWeight: "bold"
						}}
					>
						ThreadPath
					</Typography>

					<Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
						<IconButton
							size="large"
							aria-label="account of current user"
							aria-controls="menu-appbar"
							aria-haspopup="true"
							onClick={handleOpenNavMenu}
							color="inherit"
						>
							<MenuIcon />
						</IconButton>
						<Menu
							id="menu-appbar"
							anchorEl={anchorElNav}
							anchorOrigin={{
								vertical: "bottom",
								horizontal: "left",
							}}
							keepMounted
							transformOrigin={{
								vertical: "top",
								horizontal: "left",
							}}
							open={Boolean(anchorElNav)}
							onClose={handleCloseNavMenu}
							sx={{
								display: { xs: "block", md: "none" },
							}}
						>
							{LINKS.map((l) => (
								<MenuItem
									key={l.name}
									onClick={() => handleCloseNavMenu(`/domains/${domainId}/${l.link}`)}
								>
									<Typography textAlign="center">{l.name}</Typography>
								</MenuItem>
							))}
						</Menu>
					</Box>
					<Typography
						variant="h6"
						noWrap
						component="div"
						onClick={() => handleCloseNavMenu("/home")}
						sx={{
							flexGrow: 1,
							display: { xs: "flex", md: "none" },
							cursor: "pointer",
							fontWeight: "bold"
						}}
					>
						ThreadPath
					</Typography>
					<Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
						{LINKS.map((l) => (
							<Button
								key={l.name}
								onClick={() => handleCloseNavMenu(`/domains/${domainId}/${l.link}`)}
								sx={{ my: 2, color: "white", display: "block" }}
							>
								{l.name}
							</Button>
						))}
					</Box>
					<Box>
						<FormControl size={"small"}>
							<Select
								sx={{width: "300px", my: 2, color: "white"}}
								id="domain-select"
								value={domains ? (domainId ?? "") : null}
								onChange={(event) => onSelectDomain(event.target.value)}
							>
								{domains?.map(d => <MenuItem key={d.id} value={d.id}>{d.get("name")}</MenuItem>)}
							</Select>
						</FormControl>
					</Box>
					<Box>
						<IconButton
							size="large"
							onClick={signout}
							color="inherit"
						>
							<ExitToApp />
						</IconButton>
					</Box>
				</Toolbar>
			</Container>
		</AppBar>
		// <Navbar className="navbar" variant="dark">
		//     <Container className="page-container">
		//         <Navbar.Brand href="/home">UniverCity</Navbar.Brand>
		//         <Nav className="me-auto">
		//             {LINKS.map((l) => <NavLink name={l.name} link={l.link}></NavLink>)}
		//         </Nav>
		//     </Container>
		// </Navbar>
	);
}

export default NavigationBar;
